var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEnterPin = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 206.051 206.051",
    style: {
      enableBackground: "new 0 0 206.051 206.051"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10.999,
    width: 20.967,
    height: 20.967
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.999,
    width: 20.967,
    height: 20.967
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.999,
    width: 20.967,
    height: 20.967
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.999,
    y: 39,
    width: 20.967,
    height: 20.967
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.999,
    y: 39,
    width: 20.967,
    height: 20.967
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.999,
    y: 78,
    width: 20.967,
    height: 20.967
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.999,
    y: 78,
    width: 20.967,
    height: 20.967
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.115,82.953c-2.857,0-5.548,0.718-7.911,1.973c-3.056-4.444-8.171-7.368-13.96-7.368c-2.869,0-5.57,0.722-7.94,1.986 c-3.059-4.422-8.16-7.33-13.932-7.33c-1.716,0-3.373,0.256-4.936,0.733V52.871c0-9.338-7.598-16.936-16.937-16.936 c-9.338,0-16.936,7.598-16.936,16.936v50.972c-5.098-1.628-10.883-0.837-15.45,2.65c-7.422,5.667-8.85,16.316-3.183,23.738 l24.575,32.185c2.837,5.249,6.628,10,11.282,14.011l0.001,11.626c0.001,9.924,8.076,17.998,18,17.998h29.038 c9.924,0,17.999-8.074,18-17.999l0.001-11.625c10.983-9.466,17.224-23.022,17.224-37.646V99.889 C195.052,90.55,187.454,82.953,178.115,82.953z M87.397,116.03c2.163-1.65,5.269-1.235,6.919,0.927l1.249,1.636v16.268 l-9.096-11.913C84.817,120.785,85.234,117.681,87.397,116.03z M183.052,138.781c0,11.867-5.418,22.81-14.864,30.021 c-1.487,1.135-2.359,2.898-2.359,4.769l-0.001,14.479c0,3.309-2.692,6-6,6h-29.038c-3.308,0-5.999-2.691-6-6l-0.001-14.48 c0-1.87-0.872-3.634-2.359-4.769c-9.446-7.212-14.864-18.154-14.864-30.021v-85.91c0-2.722,2.214-4.936,4.936-4.936 s4.937,2.214,4.937,4.936v62.587c0,3.313,2.687,6,6,6s6-2.687,6-6V89.15c0-2.722,2.214-4.936,4.936-4.936s4.936,2.214,4.936,4.936 v26.846c0,3.313,2.687,6,6,6s6-2.687,6-6V94.494c0-2.722,2.215-4.936,4.937-4.936s4.936,2.214,4.936,4.936v3.815h0.08 c-0.049,0.521-0.08,1.046-0.08,1.58v15.569c0,3.313,2.687,6,6,6s6-2.687,6-6V99.889c0-2.722,2.215-4.936,4.937-4.936 s4.936,2.214,4.936,4.936V138.781z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnterPin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/enter_pin.5c399c2c.svg";
export { ForwardRef as ReactComponent };